import { useState } from "react"

import AppShell from "@/components/tuw/AppShell"
import ProfileHeader from "@/components/tuw/profile/ProfileHeader"
import StatStrip from "@/components/tuw/profile/StatStrip"
import InfoCard from "@/components/tuw/profile/InfoCard"
import InsiderCard from "@/components/tuw/profile/InsiderCard"
import RewardsCard from "@/components/tuw/profile/RewardsCard"
import QuickLinks from "@/components/tuw/profile/QuickLinks"
import EditProfileModal from "@/components/tuw/profile/EditProfileModal"

// Atrium item 3 — the customer Profile: a net-new identity / overview surface.
// A single presenter (CustomerProfilePresenter) spans User + Customer; the edit
// modal writes back through the session-authenticated PATCH /profile (Flag F1),
// and the redirect re-renders this page with the persisted values. Insider state
// + rewards figures are all server-sourced (D5/D6) — nothing is hardcoded here.
export default function Profile({ profile }) {
  const [editing, setEditing] = useState(false)
  const [avatarUrl, setAvatarUrl] = useState(profile.identity?.avatarUrl ?? null)
  const identity = { ...profile.identity, avatarUrl }

  return (
    <>
      <div className="mx-auto flex w-full max-w-[960px] flex-col gap-[22px] px-[30px] pt-[26px] pb-[60px]">
        <ProfileHeader identity={identity} onEdit={() => setEditing(true)} />
        <StatStrip stats={profile.stats} />

        {/* P8-H7 "Muster" — `.pf-grid` is 1-col at ≤860 (design/spec/account/profile.html
            `@media (max-width:860px)`). Tailwind v4 compiles `min-[861px]` to
            `@media (width >= 861px)`, so 861 is the FIRST two-column width; `lg:`
            (1024) held the stack 163px too wide. */}
        <div
          data-testid="profile-grid"
          className="grid grid-cols-1 items-start gap-[22px] min-[861px]:grid-cols-[1.55fr_1fr]"
        >
          <div className="flex min-w-0 flex-col gap-[22px]">
            <InfoCard identity={identity} contact={profile.contact} onEdit={() => setEditing(true)} />
          </div>
          <div className="flex min-w-0 flex-col gap-[22px]">
            <InsiderCard insider={profile.insider} />
            <RewardsCard rewards={profile.rewards} />
            <QuickLinks links={profile.quickLinks} />
          </div>
        </div>
      </div>

      <EditProfileModal
        open={editing}
        onOpenChange={setEditing}
        identity={identity}
        editable={profile.editable}
        onAvatarChange={setAvatarUrl}
      />
    </>
  )
}

// `active="Profile"` matches no NAV key — the sidebar-foot account block
// self-activates on /profile — which is intentional and harmless.
Profile.layout = (page) => (
  <AppShell active="Profile" crumb={["Account", "Profile"]}>
    {page}
  </AppShell>
)
